import React, { useEffect, useState } from "react";
import { Button, DatePicker, message, Tabs } from "antd";
import { getIrrigationByExploitationAndDate } from "../../../Utils/informations/irrigation";
import moment from "moment";
import IrrigationTable from "./IrrigationTable";
import Loading from "../../Shared/Loading";
import ByValveTable from "./ByValveTable";
import VolumesByValveHectare from "./VolumesByValveHectare ";
import { useNavigate } from "react-router-dom";
import Title from "antd/es/typography/Title";
import { useSelector } from "react-redux";

const { RangePicker } = DatePicker;
const { TabPane } = Tabs;

const IrrigationDashboard = ({ exploitationId }) => {
  // default date range is 10 days
  const [dateRange, setDateRange] = useState([
    moment().subtract(10, "days"),
    moment(),
  ]);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const userRole = useSelector((state) => state.user.userRole.name);

  const userLink = () => {
    if (userRole === 'client') {
      return '/client';
    } else if (userRole === 'admin' || userRole === 'superadmin') {
      return '/admin';
    } else if (userRole === 'domain_manager') {
      return '/domain-manager';
    } else if (userRole === 'exploitation_manager') {
      return '/exploitation-manager';
    }
  };


  useEffect(() => {
    const fetchData = async () => {
      try {
        //extracting date as a string
        const start_date = dateRange[0].format("YYYY-MM-DD");
        const end_date = dateRange[1].format("YYYY-MM-DD");
        const data = await getIrrigationByExploitationAndDate(
          exploitationId,
          start_date,
          end_date
        );
        setData(data);
        setLoading(false);
        setError(null);
      } catch (error) {
        // handle error
        // check for network error
        if (!error.response) {
          console.error("Network error:", error);
          setError("Erreur réseau. Veuillez réessayer");
          message.error("Erreur réseau. Veuillez réessayer");
        } else if (error.response.status === 404) { // check for 404 error
          message.error("Aucune donnée trouvée pour cette exploitation");
          setError(
            "Aucune donnée trouvée pour cette exploitation pour la période sélectionnée"
          );
          setData([]);
        } else { // check for other errors
          console.error("Error fetching irrigation data:", error);
          setError("Une erreur est survenue lors du chargement des données.");
        }
      }
    };
    fetchData();
  }, [exploitationId, dateRange]);

  const handleChangeDateRange = (dates) => {
    if (dates === null) setDateRange([moment().subtract(10, "days"), moment()]);
    else setDateRange(dates);
  };

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div className="p-4 overflow-x-scroll w-full">
          <div className="flex justify-between">
            <Title level={2}>Irrigation</Title>
            <Button
              className="mb-8 bg-blue-500 text-white fonst-semibold hover:bg-blue-600 transition-colors duration-300"
              onClick={() => navigate(`${userLink()}/exploitation/${exploitationId}/info/sol`)}
            >
              Voir les informations sur le sol
            </Button>

          </div>
          <RangePicker
            onChange={handleChangeDateRange}
            className="mb-4"
            style={{ marginBottom: "20px" }}
          />
          {error == null && (
            <Tabs defaultActiveKey="1">
              <TabPane tab="Irrigation par secteur" key="1">
                <IrrigationTable data={data} dateRange={dateRange} />
              </TabPane>

              {userRole === 'superadmin' &&
                <>
                  <TabPane tab="Irrigation par vanne" key="2">
                    <ByValveTable data={data} dateRange={dateRange} />
                  </TabPane>
                  <TabPane tab="Irrigation par ha" key="3">
                    <VolumesByValveHectare data={data} dateRange={dateRange} />
                  </TabPane>
                </>
              } 
            </Tabs>
          )}
        </div>
      )}
    </>
  );
};

export default IrrigationDashboard;
